/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Pricing_DescriptionInputs */

const en_seo_pricing_description = /** @type {(inputs: Seo_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a plan for submissions, sponsorships, API usage, and AI playground access.`)
};

const zh_seo_pricing_description = /** @type {(inputs: Seo_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择提交、赞助、API 调用与 AI 试玩所需的套餐。`)
};

/**
* | output |
* | --- |
* | "Choose a plan for submissions, sponsorships, API usage, and AI playground access." |
*
* @param {Seo_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_pricing_description = /** @type {((inputs?: Seo_Pricing_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Pricing_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_pricing_description(inputs)
	return zh_seo_pricing_description(inputs)
});
export { seo_pricing_description as "seo.pricing.description" }